import { CUSTOM_EVENTS } from './constants'

function initialiseDlProxy() {
  window.dataLayer = window.dataLayer || []

  const handler = {
    apply: function (target: any, thisArg: any, argumentsList: any) {
      const result = Reflect.apply(target, thisArg, argumentsList)
      document.dispatchEvent(
        new CustomEvent(CUSTOM_EVENTS.DATA_LAYER_CHANGE, {
          detail: argumentsList,
        }),
      )
      return result
    },
  }

  if (window) {
    window.dataLayer.push = new Proxy(window.dataLayer.push.bind(window.dataLayer), handler)
  }
}

export default initialiseDlProxy
